import { render, staticRenderFns } from "./TableObjectDialog.vue?vue&type=template&id=2edce7a5&scoped=true"
import script from "./TableObjectDialog.vue?vue&type=script&lang=js"
export * from "./TableObjectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edce7a5",
  null
  
)

export default component.exports